"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isScheduleGroup(object) {
    return checkScheduleGroup(object).fulfilled;
}
exports.isScheduleGroup = isScheduleGroup;
function checkScheduleGroup(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("name"), __1.hasArray("items", __1.isRecord(__1.hasString("id"), __1.hasString("userId").optional(), __1.hasString("resourceId").optional()))).withOptions(options).explain();
}
exports.checkScheduleGroup = checkScheduleGroup;
//# sourceMappingURL=ScheduleGroup.js.map